import serviceMarketingCategoriesApi from "@/api/serviceMarketingCategories";
const state = {};
const actions = {
    getAll(context) {
        return serviceMarketingCategoriesApi.getAll();
    },
    get(context, payload) {
        return serviceMarketingCategoriesApi.get(payload.id);
    },
    create(context, payload) {
        return serviceMarketingCategoriesApi.create(payload.serviceMarketingCategory);
    },
    edit(context, payload) {
        return serviceMarketingCategoriesApi.edit(payload.id, payload.serviceMarketingCategory);
    }
};
const getters = {};
const mutations = {};
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
